import { EMPTY_LIST } from '../../../../constants/common'

function mapGretaAIChatProjectSubject(subject) {
  return subject
    ? {
        building: {
          address: subject.building.address,
          hasAccess: subject.building.has_access,
          id: subject.building.id,
          number: subject.building.number,
        },
        requests: subject.requests,
        type: subject.type,
      }
    : null
}

export function mapGretaAIChatProject(project) {
  return {
    chatIds: project.conversation_ids,
    documentsCount: project.documents_count,
    id: project.id,
    lastActivityAt: new Date(project.last_activity).getTime(),
    name: project.name,
    subject: mapGretaAIChatProjectSubject(project.subject),
    textsCount: project.texts_count,
  }
}

export function getGretaAIChatProjectsWithChats(projects, chats) {
  const chatById = new Map(chats.map(chat => [chat.id, chat]))

  return projects.map(project => ({
    ...project,
    chats: project.chatIds
      .filter(chatId => chatById.has(chatId))
      .map(chatId => chatById.get(chatId)),
  }))
}

export function mapGretaAIChatProjects(response) {
  return (response?.data?.results ?? EMPTY_LIST).map(mapGretaAIChatProject)
}

export function renameGretaAIChatProject(projects, { id, name }) {
  return projects.map(project =>
    project.id === id ? { ...project, name } : project
  )
}

export function removeGretaAIChatProject(projects, projectId) {
  return projects.filter(project => project.id !== projectId)
}
